module.exports = __webpack_public_path__ + "img/FinalTransparent_164-50.cf251e96.png";